function AppController($state) {
	var vm = this;
}

angular
	.module('common')
	.controller('AppController', AppController);
